<template style="background-color: lightgrey;">
  <b-card-body style="background-color: lightgrey">
    <b-form @submit="onSubmit">
      <b-form-group id="input-group-1" label-for="input-1" label-class="formLbl">
        <b-input-group is-text class="mb-2 mr-sm-2 mb-sm-0" style="border: #333333 2px solid; border-radius: 8px;" >
          <b-input-group-prepend>
            <span class="input-group-text">          
              <font-awesome-icon icon="fa-solid fa-user" />
            </span>
          </b-input-group-prepend>
          <b-form-input
            id="input-1"
            v-model="form.username"
            type="text"
            :placeholder="$t('USERNAME')"
            required
            
          ></b-form-input>
        </b-input-group>
      </b-form-group>
      
      <b-form-group id="input-group-2" label-for="input-2" label-class="formLbl">
        <b-input-group is-text class="mb-2 mr-sm-2 mb-sm-0" style="border: #333333 2px solid; border-radius: 8px;">
          <b-input-group-prepend>
            <span class="input-group-text">          
              <font-awesome-icon icon="fa-solid fa-lock" />
            </span>
          </b-input-group-prepend>
          <b-form-input
            id="input-2"
            v-model="form.password"
            type="password"
            :placeholder="$t('PASSWORD')"
            required
          ></b-form-input>
        </b-input-group>
      </b-form-group>
      <b-row>
        <b-form-checkbox
            id="input-3"
            v-model="form.StaySignedIn"
            class="float-right text-center"
            disabled
          >{{$t('STAY_SIGNED_IN')}}
        </b-form-checkbox>
      </b-row>
      <br/>
      <div class="text-center">
        <b-button
          type="submit"
          style="background-color: #602f6b;"
        >{{$t('LOGIN')}}</b-button>
       <!-- <span class="flex-fill align-middle">
          <b-form-hidden
            id="input-3"
            v-model="form.StaySignedIn"
            class="float-right align-middle"
            hidden
          >{{$t('STAY_SIGNED_IN')}}</b-form-hidden>
        </span> -->
      </div>
      <br/>
      <small class="text-center" style="margin-top:15px;">
        <span class="text-center">
          <a href="#" class="text-center" style="color: #333333;" v-on:click="gotoReset();">{{$t('FORGOT_PWD')}}</a>
        </span>
      </small>
    </b-form>
  </b-card-body>
</template>
<style>
.formLbl {
  color: #333333 !important;
  font-family: 'Lato', sans-serif;
}
</style>
<script>
import { ajaxPost } from "../ajax";
import { Base64 } from "js-base64";
import {apiUrl} from "@/main";


export default {
  props: ["token"],
  data: function() {
    return {
      form: {
        username: "",
        password: "",
        StaySignedIn: true,
        name:""
      }
    };
  },
  created: function() {
    //check for token in localStorage and redirect if exists
    var dta = {
      Token: null,
      IsAdmin: false,
      IsTeacher: false,
      name:null
    };
    
    this.$emit("setData", dta);
  },
  methods: {
    onSubmit: function(event) {
      event.preventDefault();

      //ajax here'
      //window.alert(this.form.username + this.form.password);
      ajaxPost(
        apiUrl() + "/auth/login",
        {
          Username: this.form.username,
          Password: this.form.password,
          StaySignedIn: this.form.StaySignedIn,
        },
        this.dataSuccessLoad,
        this.loginFailed
      );
    },
    gotoReset() {
      this.$router.push("/pwreset");
    },
    dataSuccessLoad: function(res) {
      var tokenBody = JSON.parse(Base64.decode(res.Token.split(".")[1]));
      var dta = {
        Token: res.Token,
        IsAdmin: false,
        IsTeacher: false,
        name: res.name
      };
      localStorage.Name = res.name;
      
      for (var a = 0; a < tokenBody.Groups.length; a++) {
        switch (tokenBody.Groups[a].toLowerCase()) {
          case "platformadmin":
            dta.IsAdmin = true;
            dta.IsTeacher = true;
            break;

          case "teacher":
            dta.IsTeacher = true;
            break;

          case "admin":
            dta.IsTeacher = true;
            break;

          default:
            break;
        }
      }

      this.$emit("setData", dta);

      if (res.Redirect != null) this.$router.push(res.Redirect);
      else if(dta.IsAdmin) this.$router.push('landing/admin')
      else if(dta.IsTeacher) this.$router.push('landing/teacher')
      else  this.$router.push('landing/student')
    },
    loginFailed: function() {
      this.$emit("loginfailed");
    }
  }
};
</script>